import React, { useState, useEffect, useRef } from "react";
import {
    Container, Row, Col, Card,
    CardBody,
    CardHeader,
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Nav, Modal, ModalBody, ModalHeader, ModalFooter, Collapse,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Progress,
} from 'reactstrap';
import Flatpickr from "react-flatpickr";
import api from '../../api'
import LineItems from './LineItems'
import Attachment from './attachment'
import EpoTotals from './EpoTotals'
import Comments from "./comments";
import Select from 'react-select';
import classnames from "classnames";
import EpoLimitNote from "./EpoLimitNote";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getEpoPdfBase64 } from "./epoToPdf";  // ✅ add this import at top
// Round EPO-Final — the ONE source of legal-entity codes/labels (also used
// by the PDF and the list filters). Arbitrary text can never become a company.
import { EPO_COMPANY_OPTIONS, normalizeEpoCompanyCode } from "./epoCompanyBranding";
import useAuth from "../Personal Attendance/useAuth";  // R17: detect Finance/Babu/IT-Admin to show Mark-Processed toggle
// R40 — onCreated prop removed (was destructured but never invoked;
//       refresh after save goes through navigate("/epo", { state: { refresh: true } })
//       which AllTasks picks up via location.state in its useEffect).
const CreateEoForm = ({ mode, epoNumber, onCancel }) => {
    const [totals, setTotals] = useState({
        subTotal: 0,
        milesTraveled: 0,
        mileageRate: 0.7,
        shippingCharges: 0,
        grandTotal: 0
    });

    const [epoLines, setEpoLines] = useState([]);
    const [epoAttachments, setEpoAttachments] = useState([]);
    const [activeVerticalTab, setactiveVerticalTab] = useState(7);
    const [passedverticalSteps, setPassedverticalSteps] = useState([1]);
    function toggleVerticalTab(tab) {
        if (activeVerticalTab !== tab) {
            var modifiedSteps = [...passedverticalSteps, tab];

            if (tab >= 7 && tab <= 11) {
                setactiveVerticalTab(tab);
                setPassedverticalSteps(modifiedSteps);
            }
        }
    }

    // Batch F — Option B layout: single scrolling page of collapsible sections,
    // fill in ANY order (no forced sequence). Basic Details open on load; the
    // rest collapsed but each header shows a live one-line summary + status.
    const [openSections, setOpenSections] = useState({ basic: true, lines: false, attach: false, comments: false });
    const toggleSection = (key) => setOpenSections((p) => ({ ...p, [key]: !p[key] }));
    const [savedEpoNum, setSavedEpoNum] = useState(null);

    // R17 — Finance edit-on-approve: when the user has Finance/Babu/IT-Admin
    // access, expose a "Mark as Processed/Paid" toggle alongside Save.
    const auth = useAuth();
    const isFinanceFlavor = !!(auth?.isBabu || auth?.isFinance || auth?.isItAdmin);
    // R32d — records whether the last successful save was a PUT (update)
    // or a POST /epo/create (create). The modal branches on this rather
    // than on finalMode/finalEpoNumber, which can be polluted by stale URL
    // query params (?epoNumber=X) leftover from a previous edit session.
    const [lastSavedOp, setLastSavedOp] = useState(null); // null | "create" | "update"
    const [paymentIssued, setPaymentIssued] = useState(false);
    const [originalPaymentIssued, setOriginalPaymentIssued] = useState(false);
    // R31 — edit-mode context (legacy "Review EPO" shows creator + date + status).
    const [epoCreatedByEmpId, setEpoCreatedByEmpId] = useState("");
    const [epoCreatedByName, setEpoCreatedByName] = useState("");
    const [epoCreatedDate, setEpoCreatedDate] = useState(null);
    const [epoStatus, setEpoStatus] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);
    const [useEmployeeAsPayee, setUseEmployeeAsPayee] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [employeeList, setEmployeeList] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [vendorName, setVendorName] = useState("");
    const [vendorId, setVendorId] = useState("");
    const [street, setStreet] = useState("");
    // Go-live parity (2026-09-24): EPO#S12 — second address line (vendor
    // Address2 + Address3, legacy Street2).
    const [street2, setStreet2] = useState("");
    // Go-live parity (2026-09-24): EPO#S6 — legacy NeedCheckBy: the check-needed
    // date (Check Request / Cash Advance, "M/D/YYYY") or days to pay (Pay When Billed).
    const [needCheckBy, setNeedCheckBy] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zip, setZip] = useState("");
    const [phone, setPhone] = useState("");
    const [country, setCountry] = useState("");
    const [fax, setFax] = useState("");
    const [email, setEmail] = useState("");
    const [purpose, setPurpose] = useState("");
    // Round EPO-Final (owner-approved) — the EPO's OWN legal entity
    // (SSWHITE | SHUKLA_MEDICAL | SHUKLA_SURGICAL_SUPPORT). "" = not picked
    // yet; drafts may save without it, Submit requires it (server enforces
    // the same). NOT the vendor — vendorName/company stays the Payee.
    const [owningCompany, setOwningCompany] = useState("");
    const [epoType, setEpoType] = useState("");
    // Round EPO-Pay-1 audit fix: same truthy-string bug class as
    // readyPayment — useState("false") made these render CHECKED on a
    // fresh form. payRaise (EU MDR) is display/attestation-only exactly
    // as in legacy (never persisted there either); iamUser now round-
    // trips to EpoHeader.UserOfProduct (gap B).
    const [payRaise, setPayRaise] = useState(false);
    const [iamUser, setIamUser] = useState(false);
    // Round EPO-Pay-1 audit fix: this was useState("false") — a TRUTHY
    // string, so brand-new EPOs silently saved ReadyForPayment=true no
    // matter what the user saw. Now a real boolean; the receipt-method
    // handler above sets the proper default when a method is chosen.
    const [readyPayment, setReadyPayment] = useState(false);
    const [receiptMethod, setReceiptMethod] = useState("");

    // Round EPO-Pay-1 (owner request #3) — legacy EpoNew.vb
    // radioShipping_CheckedChanged parity, extended per owner decision:
    //   "Shipping to Receive Goods" → Ready-for-Payment UNCHECKED and
    //   locked (goods must be received first);
    //   any OTHER receipt method → defaults to CHECKED (the user may
    //   still uncheck it).
    // Applied only on a USER method change, so edit-mode loads keep the
    // saved header value untouched.
    const onReceiptMethodChange = (value) => {
        setReceiptMethod(value);
        if (value === "Shipping to Receive Goods") {
            setReadyPayment(false);
        } else {
            setReadyPayment(true);
        }
    };
    const [paymentType, setPaymentType] = useState("");
    const [cards, setCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState("");
    const [modal_backdrop, setmodal_backdrop] = useState(false);
    const [modal_backdropsuccess, setmodal_backdropsuccess] = useState(false);
    const [epoComments, setEpoComments] = useState({
        purchaseNotes: "",
        internalNotes: ""
    });
    const tog_backdrop = () => setmodal_backdrop(!modal_backdrop);
    const tog_backdropsuccess = () => setmodal_backdropsuccess(!modal_backdropsuccess);
    useEffect(() => {
        if (paymentType === "Corporate Credit Card") {
            api.get("Registration/all")
                .then(res => setCards(res.data))
                .catch(err => console.error(err));
        }
    }, [paymentType]);
    useEffect(() => {
        api.get("WhosInBuilding/userList")
            .then(res => setEmployeeList(res.data || []))
            .catch(() => setEmployeeList([]));
    }, []);

    // Round EPO-Pay-1 (owner requests #1/#2): the vendor master loads
    // UNCONDITIONALLY — it is needed in BOTH modes now. Employee mode
    // matches the employee's NAME against it (legacy EpoNew.fillEmp →
    // GetVendorById → displayEpoVendor: employees exist in the vendor
    // master, e.g. AKASH SHARMA → AKA13, and the address comes from the
    // VENDOR record, not the HR record). And the Vendor ID box is now a
    // two-way lookup in both modes.
    useEffect(() => {
        api.get("registration/by-company?co=SSW")
            .then(res => setVendorList(res.data || []))
            .catch(() => setVendorList([]));
    }, []);

    // Shared "displayEpoVendor" — fill every payee field from one vendor
    // master record (legacy displayEpoVendor parity).
    const applyVendorRecord = (v) => {
        if (!v) return;
        setVendorName(v.vendor || "");
        setVendorId(v.vendorId || "");
        setStreet(v.address || "");
        setStreet2(v.address2 || v.Address2 || "");   // Go-live parity (2026-09-24): EPO#S12
        setCity(v.city || "");
        setState(v.state || "");
        setZip(v.zip || "");
        setPhone(v.phone || "N/A");
        setCountry(v.country || "N/A");
        setFax(v.fax || "N/A");
        setEmail(v.email || "N/A");
    };

    // Round EPO-Pay-1 audit fix (gap A) — EDIT MODE: the header load sets
    // the name/vendor fields but never restored the Employee picker, so
    // editing an employee-payee EPO showed "Search employee..." empty —
    // the same inconsistency the owner flagged for the Vendor ID path,
    // in a different door. This effect matches the stored payee name
    // against the employee list once both are available (the two loads
    // race on mount, so it waits for whichever arrives last). It runs a
    // single restore attempt per session (ref-gated) so a user who
    // deliberately CLEARS the picker isn't fought by re-selection.
    const employeeRestoreTriedRef = useRef(false);
    useEffect(() => {
        if (employeeRestoreTriedRef.current) return;
        if (!useEmployeeAsPayee) return;
        if (selectedEmployeeId) { employeeRestoreTriedRef.current = true; return; }
        if (!vendorName || employeeList.length === 0) return;
        employeeRestoreTriedRef.current = true;
        const nm = String(vendorName).trim().toUpperCase();
        const emp = employeeList.find(x =>
            String(x.name || "").trim().toUpperCase() === nm);
        if (emp) setSelectedEmployeeId(emp.empId);
    }, [useEmployeeAsPayee, selectedEmployeeId, vendorName, employeeList]);

    // Owner request #2 — typing a Vendor ID auto-fills everything else
    // (legacy Button7 "Load" / txtVendorID flow), in BOTH vendor and
    // employee modes. Runs on blur; unknown IDs keep the typed value so
    // free-form entry still works.
    const onVendorIdBlur = () => {
        const typed = String(vendorId || "").trim();
        if (!typed) return;
        const v = vendorList.find(x =>
            String(x.vendorId || "").trim().toUpperCase() === typed.toUpperCase());
        if (v) {
            applyVendorRecord(v);
            setSelectedVendorId(v.vendorId);
            // Round EPO-Pay-1 follow-up (owner): in EMPLOYEE mode, loading
            // by Vendor ID must also resolve the Employee picker — the
            // reverse of the name→vendor match (AKA13 → AKASH SHARMA →
            // employee record), so the whole payee block, including the
            // Employee dropdown, reflects one consistent person.
            if (useEmployeeAsPayee) {
                const vName = String(v.vendor || "").trim().toUpperCase();
                const emp = employeeList.find(x =>
                    String(x.name || "").trim().toUpperCase() === vName);
                if (emp) {
                    setSelectedEmployeeId(emp.empId);
                    // Keep the display name in the employee's casing,
                    // matching what picking them directly would show.
                    setVendorName(`${emp.name}`);
                }
            }
        }
    };

    const onToggleUseEmployee = (e) => {
        const checked = e.target.checked;
        setUseEmployeeAsPayee(checked);
        setSelectedEmployeeId("");
        setSelectedVendorId("");
        setVendorName("");
        setVendorId("");
        setStreet("");
        setStreet2("");   // Go-live parity (2026-09-24): EPO#S12
        setCity("");
        setState("");
        setZip("");
        setPhone("");
        setCountry("");
        setFax("");
        setEmail("");
    };

    const onEmployeeChange = (e) => {
        const empId = e.target.value;
        setSelectedEmployeeId(empId);

        const emp = employeeList.find(x => String(x.empId) === String(empId));
        if (!emp) return;

        // Round EPO-Pay-1 (owner request #1) — legacy fillEmp parity: the
        // selected employee's VENDOR-MASTER record (matched by name, e.g.
        // AKASH SHARMA → AKA13) supplies the Vendor ID and the address —
        // the previous code stuffed the EmpId (3325) into Vendor ID and
        // left the address blank because the HR list has no address.
        const empName = String(emp.name || "").trim().toUpperCase();
        const v = vendorList.find(x =>
            String(x.vendor || "").trim().toUpperCase() === empName);
        if (v) {
            applyVendorRecord(v);
            // Keep the display name in the employee's casing.
            setVendorName(`${emp.name}`);
        } else {
            // No vendor record on file for this employee — fall back to the
            // HR record, with the Vendor ID left EMPTY and editable (owner
            // request #2 lets the user type/load one; never the EmpId).
            setVendorName(`${emp.name}`);
            setVendorId("");
            setStreet(emp.street || "");
            setStreet2("");   // Go-live parity (2026-09-24): EPO#S12
            setCity(emp.city || "");
            setState(emp.state || "");
            setZip(emp.zip || "");
            setPhone(emp.phone || "");
            setCountry(emp.country || "N/A");
            setFax(emp.fax || "N/A");
            setEmail(emp.email || "N/A");
        }
    };

    const onVendorChange = (e) => {
        const vid = e.target.value;
        setSelectedVendorId(vid);
        const v = vendorList.find(x => String(x.vendorId) === String(vid));
        if (v) applyVendorRecord(v); // Round EPO-Pay-1: shared displayEpoVendor
    };

    // Submit EPO
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const queryMode = query.get("mode");
    const queryEpoNumber = query.get("epoNumber");
    // R45 — when AllTasks routes a Duplicate through this form it appends
    // ?duplicated=1. The save path is still PUT (the BE already created the
    // duplicate as a real EPO), but we treat the post-save modal as a create
    // so the user gets the Submit-for-Approval button + the notification
    // email goes out. Without this flag the duplicate would silently sit in
    // PENDING with no approvers assigned and no email sent.
    const isDuplicateSession = query.get("duplicated") === "1";

    const finalMode = mode || queryMode;
    const finalEpoNumber = epoNumber || queryEpoNumber;

    // R39 — R32d diagnosis logs removed (production hygiene).

    const authUser = sessionStorage.getItem("authUser");
    const empId = authUser ? JSON.parse(authUser)?.uid : null;
    const [loading, setLoading] = useState(false);
    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    const navigate = useNavigate();
    const handleSaveEpo = async (e) => {
        // Round 3 batch — Purpose is required before anything is saved
        // (server enforces the same on POST create and PUT update).
        // Round EPO-32 (owner): payee, address, EPO details and at least one
        // line item are MANDATORY before submitting. (Fax/e-mail stay
        // optional by design.)
        {
            const missing = [];
        if (!vendorName || !String(vendorName).trim()) missing.push("Vendor / Payee Name");
        if (!street || !String(street).trim()) missing.push("Street");
        if (!city || !String(city).trim()) missing.push("City");
        if (!state || !String(state).trim()) missing.push("State");
        if (!zip || !String(zip).trim()) missing.push("Zip");
        if (!country || !String(country).trim()) missing.push("Country");
        if (!phone || !String(phone).trim()) missing.push("Phone");
        if (!epoType || !String(epoType).trim()) missing.push("EPO Type");
        if (!receiptMethod || !String(receiptMethod).trim()) missing.push("Receipt Method");
        if (!paymentType || !String(paymentType).trim()) missing.push("Payment Type");
            if (!epoLines || epoLines.length === 0) missing.push("at least one Line Item");
            if (missing.length > 0) {
                alert("Required before submitting:\n\n• " + missing.join("\n• "));   // Round EPO-32c: this form uses alert(), not toast
                return;
            }
        }
        if (!purpose || !purpose.trim()) {
            alert("Purpose is required.");
            return;
        }

        e?.preventDefault?.(); // Save as Draft / Submit EPO wrappers call without a click event

        try {
            setLoading(true);
            const receiptMap = {
                "Shipping to Receive Goods": "SHIPPING",
                "Delivered Directly to Me": "ME",
                "Personally Picked Up Goods": "PERSONALLY",
                "Nothing to Deliver": "NOTHING",
            };
            const paymentMap = {
                "Reimbursement": "REIMBURSEMENT",
                "Check Request": "CHECK",
                "Pay When Billed": "PAY",
                "Cash Advance": "CASH",
                "COD": "COD",
                "Corporate Credit Card": "CC",
            };
            const attachmentsPayload = await Promise.all(
                epoAttachments.map(async (a) => ({
                    fileName: a.fileName,
                    base64Data: a.fileObject
                        ? await fileToBase64(a.fileObject)
                        : ""
                }))
            );
            const linesPayload = epoLines.map((l) => ({
                description: l.description,
                productGroup: l.productGroup,
                dept: l.dept,
                acct: l.accountNo,
                quan: Number(l.quantity || 0),
                unitPrice: Number(l.unitPrice || 0),
                uom: l.uomFinal || "Each",

                tax: false,
                asset: !!l.assetPurchase,
                rd: !!l.rdExpense,

                discountPercent: Number(l.discountPct || 0),
                taxPercent: Number(l.taxPct || 0),
                extendedCost: Number(l.extendedCost || 0),

                gstRate: 0,
                centralGst: 0,
                stateGst: 0,
                withinGujarat: false,

                status: "Epo Created",
                // Go-live parity (2026-09-24): EPO#N11 — the stored line number of
                // an existing line, so the server updates THAT line (not by position).
                lineNum: l.lineNum ?? null
            }));
            const payload = {
                company: vendorName,
                // Round EPO-Final — legal entity; null while undecided (draft).
                owningCompany: owningCompany || null,
                vendorId,

                street1: street || "",
                street2: street2 || "",   // Go-live parity (2026-09-24): EPO#S12 (was always "")
                city,
                state,
                zip,
                country,
                phone,
                fax,
                email,

                epoRemark: purpose || "",
                epoType,
                receiptMethod: receiptMap[receiptMethod] || "",
                paymentType: paymentMap[paymentType] || "",
                ccid: paymentType === "Corporate Credit Card"
                    ? Number(selectedCard)
                    : null,

                milesTraveled: totals.milesTraveled,
                mileageRate: totals.mileageRate,
                shippingCharges: totals.shippingCharges,
                taxRate: totals.taxRate,
                approxTotal: totals.approxTotal,

                noteInternal: epoComments.internalNotes?.trim() || "",
                noteExternal: epoComments.purchaseNotes?.trim() || "",


                readyForPayment: !!readyPayment,
                userOfProduct: !!iamUser, // Round EPO-Pay-1 gap B
                // Go-live parity (2026-09-24): EPO#S6 — legacy EpoNew.vb: the date for
                // Check Request / Cash Advance, the days for Pay When Billed, else "".
                needCheckBy: (paymentType === "Check Request" || paymentType === "Cash Advance" || paymentType === "Pay When Billed")
                    ? String(needCheckBy || "").trim()
                    : "",
                sswhiteEmp: !!useEmployeeAsPayee,
                // R32b — in edit mode preserve the original creator instead of
                // sending the logged-in user. Backend's PUT ignores this field today
                // (so this is purely cosmetic / defensive), but it stops Finance/IT-
                // Admin from APPEARING to overwrite the author when inspecting the
                // request payload, and protects against any future BE change.
                // Batch 4 / Round 12 — NO hardcoded "0000" placeholder. Send the
                // real logged-in empId (or null); the backend Create endpoint is
                // authoritative and derives the creator from the signed JWT, so a
                // null here is harmless.
                createdBy: (finalMode === "edit" && epoCreatedByEmpId)
                    ? epoCreatedByEmpId
                    : (empId || null),

                lines: linesPayload,
                attachments: attachmentsPayload
            };
            // const res = await api.post("/epo/create", payload);
            // console.log("EPO Number for the test:", res.data);

            // const epoNum = res.data?.epoNumber ?? res.data?.data?.epoNumber;
            // if (!epoNum) {
            //     console.warn("Save succeeded, but epoNum not found in response.");
            // } else {
            //     setSavedEpoNum(epoNum);

            // }
            // Rounds 1–2 batch — one EPO per browser session: once a create has
            // saved (savedEpoNum set), every further Save in the SAME session
            // becomes a PUT to that EPO — Save → Save can never mint #85803/#85804
            // duplicates again. True edit sessions keep using the URL epoNumber.
            const targetEpoNumber = (mode === "edit" && epoNumber) ? epoNumber : savedEpoNum;
            const isUpdateCall = !!targetEpoNumber;

            let res;
            // R48 — if the EPO is currently APPROVED, capture the OLD PDF before
            // we save so we can attach it to the change-notification email.
            // Best-effort: if the snapshot fails, we still save — the change email
            // simply won't carry the OLD pdf.
            let oldPdfBase64 = null;
            if (mode === "edit" && epoNumber) {
                const currentStatus = (epoStatus ?? "").toString().toUpperCase();
                if (currentStatus === "APPROVED") {
                    try {
                        oldPdfBase64 = await getEpoPdfBase64(epoNumber, api);
                    } catch (preErr) {
                        console.warn("R48: pre-save OLD PDF snapshot failed", preErr);
                    }
                }
            }
            // R42 — submit-payload debug log removed.
            if (isUpdateCall) {
                res = await api.put(`/epo/${targetEpoNumber}`, payload);

                // R42 — debug log removed.
                setSavedEpoNum(targetEpoNumber);                         // keep same
                // R45 — if this is a duplicate session, route through the create
                // modal so Submit-for-Approval + notify-email run normally.
                // Rounds 1–2 batch — a create-session re-save is still a CREATE
                // outcome for the modal (keeps the Submit button visible);
                // only true edit sessions show the "EPO Updated!" branch.
                setLastSavedOp((mode === "edit" && !isDuplicateSession) ? "update" : "create");

                // R48/R53 — EDIT AFTER APPROVAL: BE signals requiresReapproval=true
                // when it had to re-route. Fire the change-notification email
                // with both old + new PDFs.
                //
                // R53 also adds:
                //   • a visible alert when re-routing FAILS so the user actually
                //     knows (was silent before — nothing happened end-to-end)
                //   • confirmation when re-routing SUCCEEDS so they know approvers
                //     were notified
                const wasApproved = (epoStatus ?? "").toString().toUpperCase() === "APPROVED";
                const needsReapproval = res?.data?.requiresReapproval === true;
                const reapprovalError = res?.data?.reapprovalError;

                if (wasApproved && reapprovalError) {
                    // Re-route failed server-side. Tell the user explicitly.
                    alert(
                        `EPO saved, but re-routing for approval FAILED:\n${reapprovalError}\n\n` +
                        `The EPO status is now PENDING but approvers have NOT been notified.\n` +
                        `Please contact IT or re-submit manually.`
                    );
                }

                if (needsReapproval) {
                    try {
                        const newPdfBase64 = await getEpoPdfBase64(targetEpoNumber, api);
                        const changeResp = await api.post(`Epo/${targetEpoNumber}/notify-change`, {
                            oldPdfBase64: oldPdfBase64 || newPdfBase64,
                            newPdfBase64,
                            fileName: `EPO-${targetEpoNumber}.pdf`,
                        });
                        // R55 — honest alert reflecting what the BE actually did.
                        //   "approvers"             → real chain re-routed, N approvers emailed
                        //   "auto-approval-creator" → creator's limit covered the edit, no
                        //                            chain triggered; creator emailed instead
                        const nt = changeResp?.data?.notifiedType;
                        const nCount = changeResp?.data?.recipientCount || 1;
                        if (nt === "auto-approval-creator") {
                            alert(
                                `EPO saved and auto-re-approved.\n` +
                                `The new amount is within your approval limit, so no chain approval was needed.\n` +
                                `A confirmation email with the OLD and NEW versions has been sent to you.`
                            );
                        } else if (nt === "approvers") {
                            alert(
                                `EPO saved and re-routed for approval.\n` +
                                `${nCount} approver(s) have been notified by email with the OLD and NEW versions attached.`
                            );
                        } else {
                            // Older BE without notifiedType — fall back to generic message.
                            alert(
                                `EPO saved and re-routed for approval.\n` +
                                `Approvers (if any) have been notified by email.`
                            );
                        }
                    } catch (changeErr) {
                        console.error("R48/R53: change-notification failed:", changeErr);
                        // Don't block save success, but tell the user the email didn't go.
                        alert(
                            `EPO saved and re-routed, but the change-notification email FAILED to send:\n` +
                            `${changeErr?.response?.data?.error || changeErr?.message || "unknown error"}\n\n` +
                            `Approvers can still see the EPO in their dashboard, but they won't get an email.`
                        );
                    }
                }

                // R17 — Finance "Mark as Processed" follow-up call. Only fires when
                // the toggle actually changed and the user has Finance/Babu/IT-Admin
                // access (backend re-validates the role).
                if (mode === "edit" && isFinanceFlavor && paymentIssued !== originalPaymentIssued) {
                    try {
                        await api.post(`epo/${targetEpoNumber}/payment`, { paid: paymentIssued });   // no leading slash; axios baseURL=/api/
                        setOriginalPaymentIssued(paymentIssued);
                    } catch (payErr) {
                        console.error("Mark-Processed failed:", payErr);
                        // Revert local toggle so it reflects DB truth.
                        setPaymentIssued(originalPaymentIssued);
                        alert(
                            payErr?.response?.data?.Message ||
                            payErr?.response?.data?.message ||
                            "Failed to update Processed state. EPO data was saved."
                        );
                    }
                }
            } else {
                res = await api.post("Epo/create", payload);       // ✅ create new (R43: case-normalized, was "/epo/create")
                const newNum = res.data?.epoNumber ?? res.data?.data?.epoNumber;
                setSavedEpoNum(newNum);
                setLastSavedOp("create");                            // R32d — modal cue
            }

            setmodal_backdrop(true);


        } catch (err) {
            console.error("Error saving EPO:", err);
            console.error("Failed to save EPO. Please check required fields.");
        } finally {
            setLoading(false);
        }

    };

    //Submit EPO End

    // Submit EPO



    // Owner spec (4 controls): Cancel (never saves) · Save as Draft (no
    // submit prompt) · Submit EPO (asks "Submit for Approval?" — decline and it
    // simply stays a DRAFT) · Delete EPO (unsubmitted only — once routed,
    // only Void is available).
    const [askSubmitAfterSave, setAskSubmitAfterSave] = useState(false);

    const handleSaveAsDraft = async () => {
        setAskSubmitAfterSave(false);
        await handleSaveEpo();
    };

    const handleSaveEpoClick = async () => {
        setAskSubmitAfterSave(true);
        await handleSaveEpo();
    };

    const handleDeleteEpo = async () => {
        const n = (mode === "edit" && epoNumber) ? epoNumber : savedEpoNum;
        if (!n) { alert("Nothing to delete — this EPO hasn't been saved yet."); return; }
        if (!window.confirm(`Delete EPO #${n}? The draft will be permanently removed.`)) return;
        try {
            await api.delete(`epo/${n}/draft`);
            alert(`EPO #${n} deleted.`);
            onCancel?.();
            // Refresh the list immediately — stale rows previously 404'd on
            // Edit/Review after a delete ("all drafts gone" confusion).
            navigate("/epo", { state: { refresh: true } });
        } catch (e) {
            console.error("Delete failed:", e);
            alert(e?.response?.data?.error || "Delete failed — only unsubmitted EPOs can be deleted (submitted EPOs can only be voided).");
        }
    };

    // Owner report — anything saved or submitted this session must appear in
    // the list the MOMENT the form is closed (previously the new draft only
    // showed after a manual refresh: Submit EPO → reimbursement-attachment
    // warning → Cancel). Same refresh pattern the Delete flow uses; a plain
    // close with nothing saved skips the refresh.
    const handleCancelForm = () => {
        onCancel?.();
        if (savedEpoNum) navigate("/epo", { state: { refresh: true } });
    };

    const submitEpoForApproval = async (epoNumToSubmit) => {
        // Round EPO-Final — company is REQUIRED to submit (drafts may omit).
        // The server enforces the same rule in SubmitAsync, so a direct API
        // call is equally blocked.
        if (!owningCompany) {
            alert("Please select which company this EPO belongs to (S.S. White Technologies, Shukla Medical, or Shukla Surgical Support) before submitting.");
            return;
        }
        // Round 3 batch — reimbursement EPOs need an attachment BEFORE they can
        // be submitted (drafts may save without one; the server enforces this
        // too, so a direct API call is equally blocked).
        if ((paymentType || "") === "Reimbursement" && (!epoAttachments || epoAttachments.length === 0)) {
            alert("Attachment is required for reimbursement EPOs before submission.");
            return;
        }

        if (!epoNumToSubmit) {
            alert("Please save the EPO first.");
            return;
        }

        try {
            setSubmitLoading(true);

            // Owner fix — the form KNOWS the employee payee: send the exact id
            // so routing anchors on THAT employee's manager (server falls back
            // to name matching for submits from the list/modal).
            const result = await api.post(`/epo/${epoNumToSubmit}/submit`, {
                payeeEmpId: useEmployeeAsPayee && selectedEmployeeId ? String(selectedEmployeeId) : null,
                // Go-live parity (2026-09-24): EPO#S5 — this page posts /notify
                // (with the PDF) right after, so the server does not mail too.
                clientSendsNotify: true,
            });

            const myData = result.data || {};
            // R42 — debug log removed.

            const autoApproved =
                myData.autoApproved ?? myData.AutoApproved ??
                myData.myData?.autoApproved ?? myData.myData?.AutoApproved;

            const approver =
                myData.currentApproverEmpId ??
                myData.CurrentApproverEmpId ??
                myData.myData?.currentApproverEmpId ??
                myData.myData?.CurrentApproverEmpId;

            // ✅ Generate PDF and send email with attachment
            // Go-live parity (2026-09-24): EPO#S5 — if the PDF cannot be built,
            // the approver e-mail still goes out (without the attachment).
            let pdfBase64 = "";
            try {
                pdfBase64 = await getEpoPdfBase64(epoNumToSubmit, api);
            } catch (pdfErr) {
                console.error("EPO PDF build failed; sending the approval e-mail without it:", pdfErr);
            }
            try {
                await api.post(`Epo/${epoNumToSubmit}/notify`, {
                    pdfBase64: pdfBase64 || "",
                    fileName: `EPO-${epoNumToSubmit}.pdf`
                });
                // R42 — email-sent debug log removed.
            } catch (emailErr) {
                // Don't block the user if email fails
                console.error("Email notification failed:", emailErr);
            }

            setmodal_backdrop(false);
            setTimeout(() => {
                navigate("/epo", { state: { refresh: true } });
            }, 100);
            setmodal_backdropsuccess(true);

        } catch (err) {
            console.error("Submit failed:", err);
            // Rounds 1 batch — close the "EPO Saved!" modal so the error is never
            // hidden behind a celebration, and surface the server's clean 409
            // { error } message from the sequential workflow instead of a raw
            // EF stack trace.
            setmodal_backdrop(false);
            const serverMsg =
                err?.response?.data?.error
                || err?.response?.data?.message
                || (typeof err?.response?.data === "string" ? err.response.data : "")
                || err?.message
                || "Submit failed";
            alert(serverMsg);
        } finally {
            setSubmitLoading(false);
        }
    };

    const handleSubmitForApproval = async () => submitEpoForApproval(savedEpoNum);



    // Submit Epo End
    const vendorOptions = vendorList.map(v => ({
        value: v.vendorId,
        label: `${v.vendorId} | ${v.vendor} | ${v.city}, ${v.state}`,
        raw: v
    }));

    const employeeOptions = employeeList.map(e => ({
        value: e.empId,
        label: `${e.name} (${e.empId})`,
        raw: e
    }));
    useEffect(() => {
        if (finalMode !== "edit" || !finalEpoNumber) return;

        const loadEpo = async () => {
            setLoading(true);
            try {
                const res = await api.get(`/Epo/${finalEpoNumber}`);
                const { header, lines, attachments } = res.data;

                // R31 — capture context fields used to render "Edit EPO #N —
                // Created by X on Date • Status: APPROVED" header line.
                // Backend includes EmpBasic so empBasic.name is the creator's name.
                setEpoCreatedByEmpId(header?.createdBy ?? "");
                setEpoCreatedByName(header?.empBasic?.name ?? header?.createdBy ?? "");
                setEpoCreatedDate(header?.createdDate ?? null);
                setEpoStatus(header?.status ?? "");

                // 🔁 reverse maps
                const receiptReverseMap = {
                    SHIPPING: "Shipping to Receive Goods",
                    ME: "Delivered Directly to Me",
                    PERSONALLY: "Personally Picked Up Goods",
                    NOTHING: "Nothing to Deliver"
                };

                const paymentReverseMap = {
                    REIMBURSEMENT: "Reimbursement",
                    CHECK: "Check Request",
                    PAY: "Pay When Billed",
                    CASH: "Cash Advance",
                    COD: "COD",
                    CC: "Corporate Credit Card"
                };

                // HEADER
                setPurpose(header.epoRemark || "");
                setVendorId(header.vendorId || "");
                setVendorName(header.company || "");
                // Round EPO-Final — normalized so a bad stored value can
                // never render as a phantom fourth company.
                setOwningCompany(normalizeEpoCompanyCode(header.owningCompany ?? header.OwningCompany) || "");
                setSelectedVendorId(header.vendorId || "");
                setReceiptMethod(receiptReverseMap[header.receiptMethod] || "");
                setPaymentType(paymentReverseMap[header.paymentType] || "");
                setUseEmployeeAsPayee(!!header.sswhiteEmp);
                setReadyPayment(!!header.readyForPayment);
                setIamUser(!!header.userOfProduct); // Round EPO-Pay-1 gap B
                setStreet(header.street1 || "");
                setStreet2(header.street2 || "");            // Go-live parity (2026-09-24): EPO#S12
                setNeedCheckBy(header.needCheckBy || "");    // Go-live parity (2026-09-24): EPO#S6
                // Go-live parity (2026-09-24): restore the saved card so a re-save
                // never sends a blank card id.
                if (header.ccid) setSelectedCard(String(header.ccid));
                setCity(header.city || "");
                setState(header.state || "");
                setZip(header.zip || "");
                setPhone(header.phone || "");
                setFax(header.fax || "");
                setEmail(header.email || "");
                setCountry(header.country || "");
                setEpoType(header.epoType || "");
                // TOTALS
                setTotals({

                    milesTraveled: header.milesTraveled || 0,
                    mileageRate: header.mileageRate || 0,
                    shippingCharges: header.shippingCharges || 0,
                    taxRate: header.taxRate || 0,
                    approxTotal: header.approxTotal || 0
                });
                // R17 — capture current paid state so the Mark-Processed toggle has
                // a baseline; only POST /payment if Finance actually changes it.
                const initialPaid = !!header.paymentIssued;
                setPaymentIssued(initialPaid);
                setOriginalPaymentIssued(initialPaid);
                setEpoComments({
                    purchaseNotes: header.noteExternal || "",
                    internalNotes: header.noteInternal || ""
                });
                // LINES
                setEpoLines(
                    lines.map(l => ({

                        lineNum: l.lineNum ?? null,   // Go-live parity (2026-09-24): EPO#N11
                        description: l.description,
                        productGroup: l.productGroup,
                        dept: l.dept,
                        accountNo: l.acct,
                        quantity: l.quan,
                        unitPrice: l.unitPrice,
                        uomFinal: l.uom,
                        assetPurchase: l.asset,
                        rdExpense: l.rd,
                        discountPct: l.discountPercent,
                        taxPct: l.taxPercent,
                        extendedCost: l.extendedCost,
                        // R32 — carry the receive state through so LineItems can
                        // render a read-only "Rcvd" column for Finance. These
                        // fields are populated by Shipping via /epo/{n}/receive
                        // and surfaced verbatim here.
                        recvd: !!l.recvd,
                        qtyRec: l.qtyRec ?? 0,
                        recvdBy: l.recvdBy ?? "",
                        dateTimeRec: l.dateTimeRec ?? null
                    }))
                );

                // ATTACHMENTS
                setEpoAttachments(
                    attachments.map(a => ({
                        id: a.id,
                        fileName: a.fileName,
                        uploadedBy: a.author,
                        timestamp: a.timestamp,
                        uploadedAt: a.timestamp,
                        existing: true,
                        // Owner fix — these rows EXIST on the server (edit and
                        // duplicate sessions both load real rows: Duplicate
                        // copies attachment rows server-side). Marking them
                        // uploaded kills the misleading "Pending Upload" badge
                        // that made saved files look unsaved.
                        _uploaded: true
                    }))
                );
            } catch (loadErr) {
                console.error("Failed to load EPO:", loadErr);
                // The loader had NO catch — any failure (e.g. a deleted EPO
                // opened from a stale list row) crashed the whole app with a
                // red runtime overlay. Handle it: explain and return to a
                // FRESH list on 404; plain alert for anything else.
                if (loadErr?.response?.status === 404) {
                    alert(`EPO #${finalEpoNumber} no longer exists — it may have been deleted. Returning to the EPO list.`);
                    navigate("/epo", { state: { refresh: true } });
                } else {
                    alert(loadErr?.response?.data?.error || "Could not load this EPO. Please refresh and try again.");
                }
            } finally {
                setLoading(false);
            }
        };

        loadEpo();
    }, [mode, epoNumber]);
    const [epoLimit, setEpoLimit] = useState(0);

    useEffect(() => {
        if (!empId) return;

        api
            .get(`/EpoLimit/employee-limit/${empId}`)
            .then(res => {
                setEpoLimit(res.data.limit);
            })
            .catch(() => {
                setEpoLimit(0);
            });
    }, [empId]);
    // R42 — EPO limit debug log removed.
    return (
        <React.Fragment>
            <Row>

                {/* R31 — title + context line. In edit mode shows "Edit EPO #N"
                    plus a subtitle "Created by X on Date • Status: APPROVED" so
                    Finance always sees who created the EPO and where it stands.
                    Mirrors legacy "Review EPO" header text. */}
                <div>
                    {/* R32 — legacy uses "Review EPO" as the title bar for the edit
                        dialog (Finance sees received state, can tweak fields, no author
                        change). We adopt the same wording. */}
                    <h4>{finalMode === "edit" && finalEpoNumber
                        ? `Review EPO #${finalEpoNumber}`
                        : "Create New EPO"}</h4>
                    {finalMode === "edit" && finalEpoNumber && (epoCreatedByName || epoStatus) && (
                        <div className="text-muted small mt-1">
                            {epoCreatedByName && (
                                <span>Created by <strong>{epoCreatedByName}</strong></span>
                            )}
                            {epoCreatedDate && (
                                <span> on <strong>{new Date(epoCreatedDate).toLocaleDateString()}</strong></span>
                            )}
                            {epoStatus && (
                                <span>{" • "}Status: <strong>{String(epoStatus).toUpperCase()}</strong></span>
                            )}
                        </div>
                    )}
                </div>

                <Col xl={12}>
                    <Card>

                        <CardBody>
                            <form className="vertical-navs-step form-steps">
                                <Row className="gy-5">
                                    <Col lg={3}>
                                        <div style={{ position: "sticky", top: "1rem" }}>

                                                <form onSubmit={(e) => e.preventDefault()}>
                                                    <div className="d-flex flex-column gap-2">
                                                        <div className="d-flex gap-2">
                                                            <Button
                                                                type="button"
                                                                onClick={handleCancelForm}
                                                                className="btn btn-danger"
                                                                block
                                                                size="sm"
                                                                disabled={loading || submitLoading}
                                                            >
                                                                Cancel
                                                            </Button>

                                                            <Button
                                                                type="button"
                                                                onClick={handleSaveAsDraft}
                                                                className="btn btn-secondary"
                                                                block
                                                                size="sm"
                                                                disabled={loading || submitLoading}
                                                            >
                                                                {loading && !askSubmitAfterSave ? "Saving..." : "Save as Draft"}
                                                            </Button>
                                                        </div>

                                                        <Button
                                                            type="button"
                                                            onClick={handleSaveEpoClick}
                                                            className="btn btn-success"
                                                            block
                                                            size="sm"
                                                            disabled={loading || submitLoading}
                                                        >
                                                            {loading && askSubmitAfterSave ? "Saving..." : "Submit EPO"}
                                                        </Button>

                                                        {/* Owner spec — Delete only while unsubmitted; after routing,
                                                            only Void is available. Backend re-validates. */}
                                                        {((mode !== "edit" && !!savedEpoNum) || (mode === "edit" && ["DRAFT", "PENDING"].includes(String(epoStatus || "").toUpperCase()))) && (
                                                            <Button
                                                                type="button"
                                                                onClick={handleDeleteEpo}
                                                                className="btn btn-outline-danger"
                                                                block
                                                                size="sm"
                                                                disabled={loading || submitLoading}
                                                            >
                                                                Delete EPO
                                                            </Button>
                                                        )}
                                                    </div>

                                                    {/* R17 — Finance/Babu/IT-Admin only: Mark EPO as Processed (paid). */}
                                                    {isFinanceFlavor && mode === "edit" && epoNumber && (
                                                        <div className="mt-3 p-2 border rounded bg-light-subtle">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="markProcessedToggle"
                                                                    checked={paymentIssued}
                                                                    onChange={(e) => setPaymentIssued(e.target.checked)}
                                                                />
                                                                <label className="form-check-label" htmlFor="markProcessedToggle">
                                                                    Mark EPO #{epoNumber} as Processed (Paid)
                                                                </label>
                                                            </div>
                                                            <div className="text-muted small mt-1">
                                                                Finance / IT Admin only. Applied when you click Submit EPO.
                                                                {paymentIssued !== originalPaymentIssued && (
                                                                    <span className="ms-2 text-warning fw-bold">(pending change)</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="mt-3">
                                                        <EpoLimitNote limit={epoLimit} currentTotal={totals.approxTotal || 0} />
                                                    </div>

                                                    <div className="mt-3">
                                                        <EpoTotals
                                                            lineItems={epoLines}
                                                            totals={totals}
                                                            onTotalsChange={setTotals}
                                                        />
                                                    </div>
                                                </form>

                                            </div>
                                    </Col>
                                    <Col lg={9}>
                                        <div className="px-lg-4">
                                            {/* Option B — collapsible sections, fill in any order */}
                                            <Card className="shadow-sm border mb-3">
                                                <CardHeader className="bg-white d-flex align-items-center justify-content-between" role="button" onClick={() => toggleSection("basic")} style={{ cursor: "pointer" }}>
                                                    <span className="fw-semibold">
                                                        <i className={`ri-checkbox-circle-fill me-2 ${ (vendorName || vendorId) ? "text-success" : "text-muted"}`}></i>
                                                        Basic Details
                                                    </span>
                                                    <span className="text-muted small">
                                                        {(vendorName || vendorId) ? (vendorName || vendorId) : "Vendor, payment, receipt"}
                                                        <i className={`ms-2 ri-arrow-${openSections.basic ? "up" : "down"}-s-line`}></i>
                                                    </span>
                                                </CardHeader>
                                                <Collapse isOpen={openSections.basic}>
                                                <CardBody>
                                                    {/* Round EPO-Final (owner-approved) — which SISTER COMPANY this
                                                        EPO belongs to. Deliberately a separate card ABOVE Vendor /
                                                        Payee so nobody conflates the two: this drives the PO
                                                        letterhead + company filters; the vendor below is who gets
                                                        paid. Radios (not free text) — only the three legal entities
                                                        exist. Required at Submit; a draft may stay unselected. */}
                                                    <Card className="shadow-sm border-0 mb-3">
                                                        <CardHeader className="bg-white border-0 pt-3 px-3 pb-2">
                                                            <h5 className="card-title fw-semibold mb-0">EPO Company (Legal Entity) <span className="text-danger">*</span></h5>
                                                        </CardHeader>
                                                        <CardBody className="pt-2">
                                                            <div className="d-flex flex-wrap gap-4">
                                                                {EPO_COMPANY_OPTIONS.map((opt) => (
                                                                    <div className="form-check" key={opt.code}>
                                                                        <input
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            name="epoOwningCompany"
                                                                            id={`owningCompany-${opt.code}`}
                                                                            checked={owningCompany === opt.code}
                                                                            onChange={() => setOwningCompany(opt.code)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`owningCompany-${opt.code}`}>
                                                                            {opt.label}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="form-text">
                                                                The company this purchase belongs to (prints on the PO letterhead). The vendor being paid is entered below.
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                    <Card className="shadow-sm border-0 mb-3">
                                                        <CardHeader className="bg-white border-0 pt-3 px-3 pb-2">
                                                            <h5 className="card-title fw-semibold mb-0">Vendor / Payee Information</h5>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <div>
                                                                <div className="row align-items-center mb-2">
                                                                    <div className="col-sm-12">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isEmployeePayee"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={useEmployeeAsPayee}
                                                                                onChange={onToggleUseEmployee}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isEmployeePayee">
                                                                                Check here if the recipient of this payment is a SS White Employee
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row g-3">
                                                                    {useEmployeeAsPayee ? (
                                                                        <div className="col-sm-6">
                                                                            <label className="form-label">Employee</label>
                                                                            <Select
                                                                                options={employeeOptions}
                                                                                value={employeeOptions.find(e => e.value === selectedEmployeeId) || null}
                                                                                onChange={(option) => {
                                                                                    setSelectedEmployeeId(option?.value || "");
                                                                                    onEmployeeChange({
                                                                                        target: { value: option?.value || "" }
                                                                                    });
                                                                                }}
                                                                                placeholder="Search employee by name or ID..."
                                                                                isClearable
                                                                            />

                                                                        </div>
                                                                    ) : (
                                                                        <div className="col-sm-6">
                                                                            <label className="form-label">Vendor</label>
                                                                            <Select
                                                                                options={vendorOptions}
                                                                                value={vendorOptions.find(v => v.value === selectedVendorId) || null}
                                                                                onChange={(option) => {
                                                                                    setSelectedVendorId(option?.value || "");
                                                                                    onVendorChange({
                                                                                        target: { value: option?.value || "" }
                                                                                    });
                                                                                }}
                                                                                placeholder="Search vendor by name, ID, city..."
                                                                                isClearable
                                                                            />

                                                                        </div>
                                                                    )}
                                                                    <div className="col-sm-6">
                                                                        <label className="form-label">Vendor ID</label>
                                                                        {/* Round EPO-Pay-1 (owner request #2): editable in both
                                                                            modes — type an ID and tab out to auto-fill the vendor
                                                                            name + address (legacy txtVendorID + Load button). */}
                                                                        <input
                                                                            className="form-control"
                                                                            value={vendorId}
                                                                            onChange={(e) => setVendorId(e.target.value)}
                                                                            onBlur={onVendorIdBlur}
                                                                            placeholder="Type a Vendor ID and tab out to load"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row g-3 mt-1">
                                                                    <div className="col-sm-6">
                                                                        <label className="form-label">Vendor / Payee Name</label>
                                                                        <input className="form-control" value={vendorName} readOnly />
                                                                    </div>

                                                                    <div className="col-sm-6">
                                                                        <label className="form-label">Phone</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={phone}
                                                                            onChange={(e) => setPhone(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    <div className="col-sm-12">
                                                                        <label className="form-label">Street</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={street}
                                                                            onChange={(e) => setStreet(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    {/* Go-live parity (2026-09-24): EPO#S12 — suite / PO box line (vendor Address2 + Address3). */}
                                                                    <div className="col-sm-12">
                                                                        <label className="form-label">Street 2</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={street2}
                                                                            onChange={(e) => setStreet2(e.target.value)}
                                                                            placeholder="Suite, P.O. Box (optional)"
                                                                        />
                                                                    </div>

                                                                    <div className="col-sm-4">
                                                                        <label className="form-label">City</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={city}
                                                                            onChange={(e) => setCity(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    <div className="col-sm-4">
                                                                        <label className="form-label">State</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={state}
                                                                            onChange={(e) => setState(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    <div className="col-sm-4">
                                                                        <label className="form-label">Zip</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={zip}
                                                                            onChange={(e) => setZip(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <label className="form-label">Country</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={country}
                                                                            onChange={(e) => setCountry(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    <div className="col-sm-4">
                                                                        <label className="form-label">Fax</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={fax}
                                                                            onChange={(e) => setFax(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    <div className="col-sm-4">
                                                                        <label className="form-label">Email</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={email}
                                                                            onChange={(e) => setEmail(e.target.value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Card>

                                                    <Card className="shadow-sm border-0 mb-3">
                                                        <CardHeader className="bg-white border-0 pt-3 px-3 pb-2">
                                                            <h5 className="card-title fw-semibold mb-0">EPO Details</h5>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <div>
                                                                <div className="row g-3 mt-1">
                                                                    <div className="col-sm-6">
                                                                        <label className="form-label">Purpose of EPO <span className="text-danger">*</span></label>
                                                                        <input className="form-control" value={purpose} onChange={(e) => setPurpose(e.target.value)} />
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <Label htmlFor="choices-multiple-remove-button" className="form-label text-dark">EPO Type</Label>
                                                                        <Input type="select" value={epoType} onChange={e => setEpoType(e.target.value)}>
                                                                            <option value="">Select One</option>
                                                                            <option>Asset Purchase</option>
                                                                            <option>Expense Purchase</option>
                                                                            <option>Travel Expense</option>
                                                                        </Input>
                                                                    </div>
                                                                    <div className="col-sm-12">
                                                                        <FormGroup check className="mb-2">
                                                                            <Input type="checkbox" checked={!!payRaise} onChange={e => setPayRaise(e.target.checked)} />
                                                                            <Label check>
                                                                                EU MDR: Will this purchase contain anything that will contact the parts we make
                                                                            </Label>
                                                                        </FormGroup>
                                                                    </div>
                                                                    <div className="col-sm-12">
                                                                        <Label className="form-label d-block mb-2">Receipt Method</Label>
                                                                        <FormGroup check inline>
                                                                            <Input
                                                                                type="radio"
                                                                                id="shipping"
                                                                                name="receiptMethod"
                                                                                value="Shipping to Receive Goods"
                                                                                checked={receiptMethod === "Shipping to Receive Goods"}
                                                                                onChange={(e) => onReceiptMethodChange(e.target.value)}
                                                                            />
                                                                            <Label check htmlFor="shipping">
                                                                                Shipping to Receive Goods
                                                                            </Label>
                                                                        </FormGroup>

                                                                        <FormGroup check inline>
                                                                            <Input
                                                                                type="radio"
                                                                                id="delivered"
                                                                                name="receiptMethod"
                                                                                value="Delivered Directly to Me"
                                                                                checked={receiptMethod === "Delivered Directly to Me"}
                                                                                onChange={(e) => onReceiptMethodChange(e.target.value)}
                                                                            />
                                                                            <Label check htmlFor="delivered">
                                                                                Delivered Directly to Me
                                                                            </Label>
                                                                        </FormGroup>

                                                                        <FormGroup check inline>
                                                                            <Input
                                                                                type="radio"
                                                                                id="picked"
                                                                                name="receiptMethod"
                                                                                value="Personally Picked Up Goods"
                                                                                checked={receiptMethod === "Personally Picked Up Goods"}
                                                                                onChange={(e) => onReceiptMethodChange(e.target.value)}
                                                                            />
                                                                            <Label check htmlFor="picked">
                                                                                Personally Picked Up Goods
                                                                            </Label>
                                                                        </FormGroup>

                                                                        <FormGroup check inline>
                                                                            <Input
                                                                                type="radio"
                                                                                id="nothing"
                                                                                name="receiptMethod"
                                                                                value="Nothing to Deliver"
                                                                                checked={receiptMethod === "Nothing to Deliver"}
                                                                                onChange={(e) => onReceiptMethodChange(e.target.value)}
                                                                            />
                                                                            <Label check htmlFor="nothing">
                                                                                Nothing to Deliver
                                                                            </Label>
                                                                        </FormGroup>
                                                                    </div>

                                                                    <div className="row g-3 mt-1">
                                                                        <div className="col-sm-6">
                                                                            <FormGroup check className="mb-2">
                                                                                <Input type="checkbox" checked={!!iamUser} onChange={e => setIamUser(e.target.checked)} />
                                                                                <Label check>
                                                                                    I am the User of this product to be purchased.
                                                                                </Label>
                                                                            </FormGroup>
                                                                        </div>
                                                                        <div className="col-sm-6">
                                                                            <FormGroup check className="mb-2">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    checked={!!readyPayment}
                                                                                    disabled={receiptMethod === "Shipping to Receive Goods"}
                                                                                    onChange={e => setReadyPayment(e.target.checked)}
                                                                                />
                                                                                <Label check>
                                                                                    EPO ready for Payment.
                                                                                    {receiptMethod === "Shipping to Receive Goods" && (
                                                                                        <span className="text-muted small ms-1">(locked — goods ship first)</span>
                                                                                    )}
                                                                                </Label>
                                                                            </FormGroup>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardBody>

                                                    </Card>
                                                    <Card className="shadow-sm border-0 mb-3">
                                                        <CardHeader className="bg-white border-0 pt-3 px-3 pb-2">
                                                            <h5 className="card-title fw-semibold mb-0">Payment Type</h5>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <div className="col-sm-12">
                                                                <Label className="form-label fw-bold">Payment Type</Label>

                                                                <div className="d-flex flex-wrap gap-4">
                                                                    {["Reimbursement", "Check Request", "Pay When Billed", "Cash Advance", "COD", "Corporate Credit Card"].map((type) => (
                                                                        <FormGroup key={type} check>
                                                                            <Input
                                                                                type="radio"
                                                                                name="paymentType"
                                                                                value={type}
                                                                                checked={paymentType === type}
                                                                                onChange={(e) => { setPaymentType(e.target.value); setNeedCheckBy(""); }}
                                                                            />
                                                                            <Label check className="ms-1">{type}</Label>
                                                                        </FormGroup>
                                                                    ))}
                                                                </div>

                                                                {/* Conditional UI based on selected type */}
                                                                {(paymentType === "Check Request" || paymentType === "Cash Advance") && (
                                                                    <div className="mt-3">
                                                                        <Label className="form-label">Please select the date</Label>
                                                                        {/* Go-live parity (2026-09-24): EPO#S6 — bound to NeedCheckBy,
                                                                            stored like legacy ToShortDateString (M/D/YYYY). */}
                                                                        <Flatpickr
                                                                            className="form-control"
                                                                            options={{ dateFormat: "n/j/Y", allowInput: true }}
                                                                            value={needCheckBy}
                                                                            onChange={(_dates, dateStr) => setNeedCheckBy(dateStr || "")}
                                                                            placeholder="Select a date"
                                                                        />
                                                                    </div>
                                                                )}

                                                                {paymentType === "Pay When Billed" && (
                                                                    <div className="mt-3">
                                                                        <Label className="form-label">Please indicate the number of days</Label>
                                                                        {/* Go-live parity (2026-09-24): EPO#S6 — bound to NeedCheckBy (days to pay). */}
                                                                        <Input
                                                                            type="number"
                                                                            className="form-control"
                                                                            min="0"
                                                                            placeholder="Enter days"
                                                                            value={needCheckBy}
                                                                            onChange={(e) => setNeedCheckBy(e.target.value)}
                                                                        />
                                                                    </div>
                                                                )}

                                                                {paymentType === "Corporate Credit Card" && (
                                                                    <div className="mt-3">
                                                                        <label className="form-label">Select Credit Card</label>
                                                                        <select
                                                                            className="form-select"
                                                                            value={selectedCard}
                                                                            onChange={e => setSelectedCard(e.target.value)}
                                                                        >
                                                                            <option value="">-- Select --</option>
                                                                            {cards.map(c => (
                                                                                <option key={c.id} value={c.id}>{c.printValue}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </CardBody>

                                                    </Card>
                                                </CardBody>
                                                </Collapse>
                                            </Card>

                                            <Card className="shadow-sm border mb-3">
                                                <CardHeader className="bg-white d-flex align-items-center justify-content-between" role="button" onClick={() => toggleSection("lines")} style={{ cursor: "pointer" }}>
                                                    <span className="fw-semibold">
                                                        <i className={`ri-checkbox-circle-fill me-2 ${ (epoLines && epoLines.length > 0) ? "text-success" : "text-muted"}`}></i>
                                                        Line Items
                                                    </span>
                                                    <span className="text-muted small">
                                                        {(epoLines && epoLines.length > 0) ? `${epoLines.length} item(s)` : "None yet"}
                                                        <i className={`ms-2 ri-arrow-${openSections.lines ? "up" : "down"}-s-line`}></i>
                                                    </span>
                                                </CardHeader>
                                                <Collapse isOpen={openSections.lines}>
                                                    <CardBody>
                                                        <LineItems lines={epoLines} setLines={setEpoLines} />
                                                    </CardBody>
                                                </Collapse>
                                            </Card>

                                            <Card className="shadow-sm border mb-3">
                                                <CardHeader className="bg-white d-flex align-items-center justify-content-between" role="button" onClick={() => toggleSection("attach")} style={{ cursor: "pointer" }}>
                                                    <span className="fw-semibold">
                                                        <i className={`ri-checkbox-circle-fill me-2 ${ (epoAttachments && epoAttachments.length > 0) ? "text-success" : "text-muted"}`}></i>
                                                        Attachments
                                                    </span>
                                                    <span className="text-muted small">
                                                        {(epoAttachments && epoAttachments.length > 0) ? `${epoAttachments.length} file(s)` : "Optional"}
                                                        <i className={`ms-2 ri-arrow-${openSections.attach ? "up" : "down"}-s-line`}></i>
                                                    </span>
                                                </CardHeader>
                                                <Collapse isOpen={openSections.attach}>
                                                    <CardBody>
                                                        <Attachment attachments={epoAttachments} setAttachments={setEpoAttachments} />
                                                    </CardBody>
                                                </Collapse>
                                            </Card>

                                            <Card className="shadow-sm border mb-3">
                                                <CardHeader className="bg-white d-flex align-items-center justify-content-between" role="button" onClick={() => toggleSection("comments")} style={{ cursor: "pointer" }}>
                                                    <span className="fw-semibold">
                                                        <i className="ri-chat-1-line me-2 text-muted"></i>
                                                        Comments
                                                    </span>
                                                    <span className="text-muted small">
                                                        Optional notes
                                                        <i className={`ms-2 ri-arrow-${openSections.comments ? "up" : "down"}-s-line`}></i>
                                                    </span>
                                                </CardHeader>
                                                <Collapse isOpen={openSections.comments}>
                                                    <CardBody>
                                                        <Comments value={epoComments} onChange={setEpoComments} />
                                                    </CardBody>
                                                </Collapse>
                                            </Card>
                                        </div>
                                    </Col>
                                </Row>
                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {loading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(255,255,255,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            <Modal
                isOpen={modal_backdrop}
                toggle={tog_backdrop}
                backdrop="static"
                id="staticBackdrop"
                centered
            >
                <ModalHeader>
                    <h5 className="modal-title" id="staticBackdropLabel">Success</h5>
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <lord-icon
                        src="https://cdn.lordicon.com/lupuorrc.json"
                        trigger="loop"
                        colors="primary:#121331,secondary:#08a88a"
                        style={{ width: "120px", height: "120px" }}>
                    </lord-icon>

                    <div className="mt-4">
                        {/* R32b — in edit mode the EPO is already submitted (and may
                            already be APPROVED). Showing "Submit for Approval" here was
                            wrong on multiple counts: (1) misleading wording ("added a new
                            EPO"), (2) the Submit endpoint gates on actor == requester so
                            Finance/IT-Admin clicking it gets "Only the requester can
                            submit this EPO", (3) the click also fires the PDF/notify
                            email which the user does NOT expect on an edit. So in edit
                            mode show "EPO Updated" + a single Close button. */}
                        {/* R32c+R32d — the modal branches on lastSavedOp, set inside
                            handleSaveEpo right after the API call. Earlier rounds used
                            finalMode/finalEpoNumber, but finalEpoNumber falls back to
                            queryEpoNumber from the URL, which carries stale ?epoNumber=X
                            params from a prior edit session. lastSavedOp reflects the
                            actual API call (PUT vs POST) and cannot lie. */}
                        {lastSavedOp === "update" ? (
                            <>
                                <h4 className="mb-3">EPO Updated!</h4>
                                <p className="text-muted mb-4">{askSubmitAfterSave ? "Your changes have been saved." : "Saved as a DRAFT — submit it anytime from My EPOs."}</p>
                                <div className="hstack gap-2 ">
                                    <Button color="primary" onClick={() => {
                                        setmodal_backdrop(false);
                                        setLastSavedOp(null);  // R39 — clear cue after dismissal
                                        navigate("/epo", { state: { refresh: true } });
                                    }}>Close</Button>
                                                {/* Owner spec — only "Submit EPO" asks to submit; Save as Draft doesn't.
                                                    Owner fix (2026-08-03): in a CREATE session epoStatus is never set,
                                                    so requiring === "DRAFT" HID the Submit button on the second
                                                    "Submit EPO" (the attach-after-first-save recovery flow). Unknown or
                                                    blank status counts as submit-capable; only routed/terminal
                                                    states hide the button. */}
                                                {askSubmitAfterSave && !["PENDING", "APPROVED", "DENIED", "REJECTED", "VOID", "CANCELLED"].includes(String(epoStatus || "").toUpperCase()) && (
                                                    <Button
                                                        className="btn btn-success"
                                                        onClick={handleSubmitForApproval}
                                                        disabled={!savedEpoNum || submitLoading}
                                                    >
                                                        {submitLoading ? "Submitting..." : "Submit for Approval"}
                                                    </Button>
                                                )}
                                </div>
                            </>
                        ) : (
                            <>
                                <h4 className="mb-3">EPO Saved!</h4>
                                <p className="text-muted mb-4">{askSubmitAfterSave ? "You have successfully added a new EPO." : "Saved as a DRAFT — submit it anytime from My EPOs."}</p>
                                <div className="hstack gap-2 ">
                                    <Button color="light" onClick={() => { setmodal_backdrop(false); setLastSavedOp(null); /* R39 */ }} >Close</Button>
                                    {/* Owner spec — only "Submit EPO" asks to submit; Save as Draft doesn't. */}
                                    {askSubmitAfterSave && (
                                        <Button
                                            className="btn btn-success"
                                            onClick={handleSubmitForApproval}
                                            disabled={!savedEpoNum || submitLoading}
                                        >
                                            {submitLoading ? "Submitting..." : "Submit for Approval"}
                                        </Button>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={modal_backdropsuccess}
                toggle={tog_backdropsuccess}
                backdrop="static"
                id="staticBackdrop"
                centered
            >
                <ModalHeader>
                    <h5 className="modal-title" id="staticBackdropLabel">Success</h5>
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <lord-icon
                        src="https://cdn.lordicon.com/lupuorrc.json"
                        trigger="loop"
                        colors="primary:#121331,secondary:#08a88a"
                        style={{ width: "120px", height: "120px" }}>
                    </lord-icon>

                    <div className="mt-4">
                        <h4 className="mb-3">EPO Submitted!</h4>
                        <p className="text-muted mb-4">You have Submitted the EPO.</p>
                        <div className="hstack gap-2 justify-content-center">
                            <Button color="light" onClick={handleCancelForm}>Close</Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default CreateEoForm;
